import { addPendoTracking } from "../../helpers/helpers";

// action types
export const SET_ERROR_STATE = "SET_ERROR_STATE";

// action creators
export const setErrorState = function (
    hasError,
    trackingEventName,
    planUUID,
    errorText
) {
    addPendoTracking(trackingEventName, planUUID, errorText);

    return {
        type: SET_ERROR_STATE,
        hasError: hasError,
        errorText: errorText,
    };
};
